import { getSleepHistoryStagesPlotData } from "./SleepHistoryStagesFormatter";
import { getSleepHistoryVitalsPlotData } from "./SleepHistoryVitalsFormatter";

export const getSleepHistoryPlotData = (sessions) => {
  return {
    sleepHistoryStagesPlotData: getSleepHistoryStagesPlotData(sessions),
    sleepHistoryVitalsPlotData: getSleepHistoryVitalsPlotData(sessions)
  };
};
